import * as types from './thematicsActionTypes';

const initialState = {
    thematics: [],
    thematicArticleList : [],
    currentThematic : "",
    thematicArticleListRetrieved : false,
    thematicArticleListRetrievalInProgress : false,
    errorCode:'',
    errorMessage: ''
};

const setThematics = (state, action) => {
    const { thematics } = action;
    return {
        ...state, 
        thematics
    }
};

const setThematicsFailed = (state, action) => {
    const { errorMessage, errorCode } = action;
    return {
        ...state,
        errorCode,
        errorMessage,
    }
};

const getArticlesByThematicStart = (state, action) => {
    return {
        ...state,
        thematicArticleListRetrievalInProgress : true,
    }
};

const getArticlesByThematicFail = (state, action) => {
    const { errorMessage, errorCode } = action;
    return {
        ...state,
        errorCode,
        errorMessage,
        thematicArticleListRetrievalInProgress : false,
    }
};

const getArticlesByThematicSuccess = (state, action) => {
    const { currentThematic, thematicArticleList } = action;
    return {
       ...state,
       currentThematic,
       thematicArticleList : thematicArticleList,
       thematicArticleListRetrievalInProgress : false,
       thematicArticleListRetrieved : true,
   } 
};

export const thematics = (state = initialState, action) => {
    switch(action.type) {
        case types.SET_THEMATICS_LIST:                      return setThematics(state, action);
        case types.SET_THEMATICS_FAILED:                    return setThematicsFailed(state, action);
        case types.RETRIEVE_THEMATIC_ARTICLE_LIST_START : return  getArticlesByThematicStart(state, action);
        case types.RETRIEVE_THEMATIC_ARTICLE_LIST_SUCCESS : return getArticlesByThematicSuccess(state, action); 
        case types.RETRIEVE_THEMATIC_ARTICLE_LIST_FAIL : return getArticlesByThematicFail(state, action);

        default:                            return state;
    }
}

export default thematics;


// WEBPACK FOOTER //
// ./src/components/Thematics/thematicsReducers.js